import { Box, Stack } from "@chakra-ui/react";
import { useEffect} from "react"


const WxLogin = () => {
  useEffect(() => {
    const WxLoginLogin: any = window;
    new WxLoginLogin.WxLogin({
      self_redirect: false,
      id: "login",
      appid: "wx257146241c98c637",
      scope: "snsapi_login",
      redirect_uri: encodeURIComponent(window.location.href),
      state: Math.random(),
      style: "black",
      href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge3dpZHRoOiAyMDBweDt9Ci5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0KLmltcG93ZXJCb3ggLnN0YXR1cyB7dGV4dC1hbGlnbjogY2VudGVyO3BhZGRpbmc6MHB4fQ=="
    });
  }, [])

  return (
    <Stack align={"center"} height={"262px"}>
      <Box id="login"></Box>
    </Stack>
  )
}

export default WxLogin